import { PopupPanelVm } from "../../panels/popup-panel-vm";
import { Lazy } from "../lazy";
import { UrlHelper } from "../html/url-helper";
import { ServiceProvider } from "../provider/service-provider";
import { DialogResultVm } from "../../checkresultdialog/dialogresultvm";
import { MessageHelper } from "../../helper/message-helper";
import { DebuggingIconsDialogGridVm } from "./debugging-icons-dialog-grid-vm";
import { ISqafIcon } from "./debugging";
import { CheckResultData } from "../../checkresultdialog/checkresultdata";

export class DebuggingIconsDialogVm extends PopupPanelVm {
	public static getInstance = Lazy.singleton(DebuggingIconsDialogVm);
	constructor() {
		super();
		this.applyPopupOptions({
			title: "Icons",
			width: "80%",
			height: "80%"
		});
	}
	public icons: KnockoutObservableArray<ISqafIcon> = ko.observableArray([]);
	public iconsGrid = new DebuggingIconsDialogGridVm(this.icons);
	public initIconsAndShowAsync = async () => {
		this.icons([]);
		let url = UrlHelper.getDataUrl("icon-ids", "#app-debug");
		let iconIdsResult: CheckResultData = await ServiceProvider.ajax.getJsonNoCacheAsync({
			url
		}).catch(() => null);
		if (!iconIdsResult) {
			MessageHelper.uiError("Could not get Icons");
			return;
		}
		if (!iconIdsResult.success) {
			DialogResultVm.showDialog(iconIdsResult);
			return;
		}
		this.icons(iconIdsResult.resultData);
		this.show();
	}

	protected initialize() { }
}